import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import type { EChessTeam } from '../chessPieces'
import { chessPieces } from '../chessPieces-sidecar'
import type { EChessPieceType } from '../chessPiecesData'
import { chessSounds } from '../sound/chessSounds-sidecar'
import { EChessMessage } from './chessMessageIds'

export interface IChessMessagePieceCreate {
  pieceId: number
  type: EChessPieceType
  team: EChessTeam
  i: number
  j: number
  energy: number
}

export const messageId = EChessMessage.PieceCreate

export function write(m: IMessageWriter, d: IChessMessagePieceCreate) {
  messageWriter.write8(m, messageId)
  messageWriter.write32(m, d.pieceId)
  messageWriter.write8(m, d.type)
  messageWriter.write8(m, d.team)
  messageWriter.write16(m, d.i)
  messageWriter.write16(m, d.j)
  messageWriter.writeFloat(m, d.energy)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, messageId)

  let d: IChessMessagePieceCreate = {
    pieceId: messageWriter.read32(m),
    type: messageWriter.read8(m),
    team: messageWriter.read8(m),
    i: messageWriter.read16(m),
    j: messageWriter.read16(m),
    energy: messageWriter.readFloat(m),
  }

  return d
}

export function test() {
  let ex: IChessMessagePieceCreate = {
    pieceId: 100,
    type: 5,
    team: 1,
    i: 7,
    j: 8,
    energy: 132.546,
  }
  messageWriter.test('piece-create', ex, write, read)
}

export function process(m: IMessageWriter, isFromHost: boolean) {
  let msg = read(m)
  if (websockets.testRequiredFromHost(isFromHost, m, messageId)) {
    return
  }

  let cp = chessPieces.findByIdSafe(msg.pieceId)
  assert.nil(
    cp,
    'message-piece-create',
    'oh no chess piece already exists',
    cp?.id,
  )

  cp = chessPieces.create(msg.type, msg.team)
  cp.id = msg.pieceId
  chessPieces.moveToIJ(cp, msg)
  cp.energy = msg.energy
  chessPieces.createRocks(cp, false)
  chessSounds.playPieceCreate()
}

export function sendMessageAndImmediatelyExecute(
  msg: IChessMessagePieceCreate,
) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}

export function sendMessageWorldState(
  msg: IChessMessagePieceCreate,
  multiId: number,
) {
  websockets._sendMessageWorldState(write, msg, multiId)
}
